export default "__VITE_ASSET__d71d1dde__"